import { render, staticRenderFns } from "./ColumnManager.vue?vue&type=template&id=431c7210&scoped=true&"
import script from "./ColumnManager.vue?vue&type=script&lang=ts&"
export * from "./ColumnManager.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnManager.vue?vue&type=style&index=0&id=431c7210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431c7210",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VIcon,VRow,VSpacer,VTextField})
